var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'money-string',
    _vm.data.className,
    _vm.highlight,
    /is-size-[1-7]/.test(_vm.data.className) ? '' : 'is-size-6',
  ],attrs:{"data-key":_vm.data.key}},[(_vm.data.attributes && _vm.types.includes(_vm.data.attributes.type))?_c('money',_vm._b({directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"input",class:['is-string', _vm.highlight],attrs:{"value":_vm.value,"disabled":true}},'money',_vm.money,false)):_vm._e(),_vm._v(" "+_vm._s(_vm.data.translate ? _vm.$t(_vm.stringified) : _vm.stringified)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }